import React, { useState, useEffect } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { siteContent } from "../content/siteContent";

const Testimonials = () => {
  const list = siteContent.testimonials;
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % list.length), 7000);
    return () => clearInterval(t);
  }, [list.length]);

  const prev = () => setI((v) => (v - 1 + list.length) % list.length);
  const next = () => setI((v) => (v + 1) % list.length);

  const current = list[i];

  return (
    <section className="bg-slate-50 py-24 relative overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 text-center relative">
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-cyan-50 flex items-center justify-center">
            <Quote className="w-8 h-8 text-[#22b8db]" />
          </div>
        </div>

        <div className="min-h-[240px] flex flex-col justify-center">
          <p className="text-lg md:text-xl text-slate-600 leading-relaxed italic mb-8 max-w-3xl mx-auto">
            &ldquo;{current.quote}&rdquo;
          </p>
          <div>
            <div className="text-lg font-bold text-[#1a3a6e] tracking-wide uppercase">
              {current.name}
            </div>
            <div className="text-slate-500 text-sm mt-1">
              {current.title}
              {current.company ? ` — ${current.company}` : ""}
            </div>
          </div>
        </div>

        {/* Controls */}
        <button
          onClick={prev}
          aria-label="Previous"
          className="absolute left-0 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow hover:bg-[#22b8db] hover:text-white text-[#1a3a6e] flex items-center justify-center transition-colors"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={next}
          aria-label="Next"
          className="absolute right-0 top-1/2 -translate-y-1/2 w-11 h-11 rounded-full bg-white shadow hover:bg-[#22b8db] hover:text-white text-[#1a3a6e] flex items-center justify-center transition-colors"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Dots */}
        <div className="flex justify-center gap-2 mt-8">
          {list.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setI(idx)}
              aria-label={`Slide ${idx + 1}`}
              className={`h-2 rounded-full transition-all ${
                idx === i ? "w-8 bg-[#22b8db]" : "w-2 bg-slate-300"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
